export default __webpack_public_path__ + "static/media/gl-ex4.a40da958.jpg";